import { render, staticRenderFns } from "./SmplEditTypesettingChild.vue?vue&type=template&id=2db44b24&scoped=true&"
import script from "./SmplEditTypesettingChild.vue?vue&type=script&lang=js&"
export * from "./SmplEditTypesettingChild.vue?vue&type=script&lang=js&"
import style0 from "./SmplEditTypesettingChild.vue?vue&type=style&index=0&id=2db44b24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db44b24",
  null
  
)

export default component.exports